export default "__VITE_ASSET__Dmg58VMe__"